// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"MultiSelectFilter_mainContainer__17qnt"};